import api from './axiosInstance';

export const getNotificationsApi = (params) => api.get('/notification-list', { params });
export const markNotificationsSeenApi = (params) => api.get('/notification-seen', { params });
